import { useSelector } from 'react-redux';

import { selectChangePlan, selectUserInfo } from '@app/redux';

export const useHasPlanChangePending = () => {
  const { hasPendingTransition, hasActivationError, hasPendingTransitionLoading } = useSelector(selectChangePlan);

  const {
    userInfo: { isPreInstall },
  } = useSelector(selectUserInfo);

  if (isPreInstall) {
    return {
      hasPlanChangePending: false,
      hasPendingTransitionLoading: false,
    };
  }

  // Return true (conservative) while still loading the pending transition data
  if (hasPendingTransitionLoading) {
    return {
      hasPlanChangePending: true,
      hasPendingTransitionLoading: true,
    };
  }

  return {
    hasPlanChangePending: hasActivationError || hasPendingTransition,
    hasPendingTransitionLoading,
  };
};
